// src/layouts/AdminBottomNav.jsx
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Calendar,
  Ticket,
  Download,
  LogOut,
} from "lucide-react";
import "./admin-bottom-nav.scss";

export default function AdminBottomNav() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    navigate("/login", { replace: true });
  };

  return (
    <nav className="admin-bottom-nav">
      <NavLink
        to="/admin/dashboard"
        className={({ isActive }) => `abn-tab${isActive ? " active" : ""}`}
      >
        <LayoutDashboard size={22} />
        <span>Dashboard</span>
      </NavLink>

      <NavLink
        to="/admin/events"
        className={({ isActive }) => `abn-tab${isActive ? " active" : ""}`}
      >
        <Calendar size={22} />
        <span>Events</span>
      </NavLink>

      <NavLink
        to="/admin/bookings"
        className={({ isActive }) => `abn-tab${isActive ? " active" : ""}`}
      >
        <Ticket size={22} />
        <span>Bookings</span>
      </NavLink>

      <NavLink
        to="/admin/export"
        className={({ isActive }) => `abn-tab${isActive ? " active" : ""}`}
      >
        <Download size={22} />
        <span>Export</span>
      </NavLink>

      <button className="abn-tab abn-logout" onClick={handleLogout}>
        <LogOut size={22} />
        <span>Logout</span>
      </button>
    </nav>
  );
}
